<template>
  <v-card flat class="colorDominant">
    <!-- Failed login attempts dialog -->

    <v-dialog
      v-model="manyInvalidLoginAttempts"
      scrollable
      max-width="400"
      persistent
      v-if="!$isAgent()"
    >
      <v-card :tile="this.$vuetify.breakpoint.xsOnly">
        <v-toolbar flat tile class="flex-grow-0">
          <v-toolbar-title class="font-weight-black title">
            {{ $t("beCarefulLoginAttemptsTitle") }}
          </v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-btn icon @click="manyInvalidLoginAttempts = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="px-8 py-4">
          <div>
            <span>
              {{ $t("beCarefulLoginAttemptsContentAfterRequisition1") }}
            </span>
            <br />
            <span>
              {{ $t("beCarefulLoginAttemptsContentAfterRequisition2") }}
            </span>
          </div>
        </v-card-text>
        <v-card-actions class="flex pa-6 pt-0 mx-auto">
          <v-btn color="primary" @click="openRecoverPassword">
            {{ $t("forgotYourPassword") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div
      class="title ml-6 py-4"
      :class="[
        $route.name === 'Login' || $route.name === 'LoginAgent'
          ? 'pl-0'
          : 'pl-12',
      ]"
    >
      {{
        !$store.getters.getShowMigrationUserLoginMessage
          ? $t("loginInput")
          : $t("welcomeToTheNewPlatform")
      }}
    </div>
    <v-divider></v-divider>

    <template v-if="$isAgent()">
      <v-tabs background-color="colorDominant colorTabs" fixed-tabs>
        <v-tab>{{ $t("agent") }} </v-tab>
        <v-tab :href="backofficeLink">
          {{ $t("managers") }} &nbsp; <v-icon>mdi-open-in-new</v-icon>
        </v-tab>
      </v-tabs>
      <v-divider></v-divider>
    </template>

    <!-- FORM LOGIN -->
    <v-scale-transition hide-on-leave>
      <v-form
        ref="form1"
        v-model="valid1"
        lazy-validation
        v-if="formLogin && !$store.getters.getShowMigrationUserLoginMessage"
      >
        <v-card-text class="px-6 mx-auto mt-4" style="max-width: 400px">
          <v-text-field
            :label="$isCreditOnline() ? $t('loginOrEmail') : 'Login'"
            icon="person"
            :rules="[rules.required, ...($isCreditOnline() ? [rules.max] : [])]"
            v-model="user.login"
            prepend-icon="mdi-account-outline"
            solo-inverted
            tabindex="6"
            clearable
            autofocus
            :counter="$isCreditOnline() ? 50 : false"
          ></v-text-field>
          <v-text-field
            :label="$t('password')"
            v-model="user.password"
            icon="mdi-lock"
            :rules="[rules.required]"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show1 ? 'text' : 'password'"
            @click:append="show1 = !show1"
            prepend-icon="mdi-lock"
            solo-inverted
            clearable
            tabindex="7"
          ></v-text-field>
          <!-- Input abaixo deixa sem sugestão de senha -->
          <!-- <v-text-field
            :class="[show1 ? 'show-password' : 'hide-password']"
            :label="$t('password')"
            v-model="user.password"
            icon="mdi-lock"
            :rules="[rules.required]"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            type="text"
            @click:append="showPassword"
            prepend-icon="mdi-lock"
            solo-inverted
            clearable
            tabindex="7"
          ></v-text-field> -->
          <vue-recaptcha
            size="invisible"
            ref="invisibleRecaptcha"
            sitekey="6LeeGAYiAAAAALHUyamQVAlJAMKhEW1v2EPo5Hjx"
            @verify="onVerify"
            @expired="onExpired"
            :loadRecaptchaScript="loadRecaptcha"
          >
          </vue-recaptcha>
        </v-card-text>

        <v-card-actions class="pa-6 pt-0 mx-auto" style="max-width: 400px">
          <div class="d-flex flex-column mx-auto" style="width: 100%">
            <v-btn
              :loading="loading"
              tabindex="8"
              type="submit"
              class="primary darken-1"
              @click.prevent="handlerLogin"
              :disabled="disabledBtnLogin || ($isCreditOnline() && !valid1)"
              id="btn_login_submit"
            >
              <template v-slot:loader>
                <div class="mr-3">
                  {{ $t("doingLogin") }}
                </div>
                <v-progress-circular
                  indeterminate
                  size="18"
                  width="2"
                ></v-progress-circular>
              </template>
              {{ $t("login") }}
            </v-btn>

            <div
              class="mt-6 d-flex justify-space-between"
              v-if="!$isAgent()"
              :class="
                $vuetify.breakpoint.width < 370 ? 'flex-column align-start' : ''
              "
            >
              <v-btn class="ml-0" text small @click="openRecoverPassword">
                {{ $t("forgotYourPassword") }}
              </v-btn>
              <v-btn class="ml-0" small text @click="openRecoverLogin">
                {{ $t("recoverLoginBtn") }}?
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-form>
      <div v-else-if="$store.getters.getShowMigrationUserLoginMessage">
        <v-card-text
          class="text-center headline font-weight-light px-6 mt-8 pb-10"
        >
          <div>
            <v-icon style="font-size: 80px">mdi-email</v-icon>
          </div>
          <div>
            <div>
              <h3 class="pb-4 green--text">
                {{ $t("setNewPasswordByEmail") }}
              </h3>
              <div class="title">
                <span class="pb-4 orange--text">
                  {{ $t("important") }}
                </span>
                {{ $t("setNewPasswordByClickingLinkEmail") }}
                <a
                  :href="`//${migrationUserEmail.split('@')[1]}`"
                  target="_blank"
                >
                  {{ migrationUserEmail }}</a
                >.
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn class="primary" @click="resendEmail" :loading="resendingEmail">
            {{ $t("resendEmail") }}
          </v-btn>
        </v-card-actions>
      </div>
    </v-scale-transition>

    <!-- FORM RECUPERAR SENHA -->
    <v-scale-transition hide-on-leave>
      <v-form ref="form2" v-model="valid2" lazy-validation v-if="formRecov">
        <v-card-text class="px-6 pt-4 pb-0 mx-auto" style="max-width: 500px">
          <p>{{ $t("HowRecoverPassword") }}</p>
          <v-radio-group v-model="recoverPass.choose_send" :mandatory="true">
            <v-radio :label="$t('phoneLinkSMS')" value="phone"></v-radio>
            <v-radio :label="$t('emailReciveLink')" value="email"></v-radio>
          </v-radio-group>
          <p>
            {{ $t("loginToStartProcess") }}
          </p>

          <v-text-field
            v-model="recoverPass.login"
            :rules="[rules.required]"
            :label="$t('loginInput')"
            clearable
            solo-inverted
            prepend-icon="mdi-account-box-outline"
            required
            tabindex="10"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="pa-6 mb-4 pt-0 mx-auto" style="max-width: 500px">
          <v-btn tabindex="13" text @click="loginModal">
            <v-icon>mdi-chevron-left</v-icon>
            {{ $t("doLogin") }}
          </v-btn>
          <div class="flex-grow-1"></div>
          <v-btn
            :loading="loading"
            tabindex="11"
            type="submit"
            color="primary"
            @click.prevent="recoverPassword"
            >{{ $t("toRecover") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-scale-transition>

    <!-- FORM RECUPERAR LOGIN -->
    <v-scale-transition hide-on-leave>
      <v-form
        ref="form3"
        v-model="valid3"
        lazy-validation
        v-if="formRecovLogin"
      >
        <v-card-text class="px-6 pt-4 pb-0 mx-auto" style="max-width: 500px">
          <p>
            {{ $t("recoverLoginMsg") }}
          </p>
          <v-text-field
            v-model="recoverLogin.cpf"
            outlined
            :rules="[rules.required]"
            label="CPF"
            v-mask="'###.###.###-##'"
          >
          </v-text-field>
          <v-radio-group
            v-model="sendingChannel"
            v-if="!$permissions().registerEmail"
            class="d-flex"
          >
            <div class="mb-2">{{ $t("textRadioRecoveryLogin") }}</div>
            <v-radio label="SMS" value="phone"></v-radio>
            <v-radio label="E-mail" value="email"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions class="pa-6 mb-4 pt-0 mx-auto" style="max-width: 500px">
          <!-- CONFIRMA ACOUNT FOR E-MAIL OR SMS -->
          <v-btn tabindex="13" text @click="loginModal">
            <v-icon>mdi-chevron-left</v-icon>
            {{ $t("doLogin") }}
          </v-btn>
          <div class="flex-grow-1"></div>
          <v-btn
            :loading="loading"
            tabindex="11"
            type="submit"
            color="primary"
            @click.prevent="recoverUsername"
            >{{ $t("recoverLoginBtn") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-scale-transition>

    <ChangePassword
      :dialog="changePasswordDialog"
      :loading="loading"
      @doLogin="doLogin"
    />
  </v-card>
</template>
<script>
import axios from "axios";
import { validate } from "@/util/form-validate";
import domainsForCaptcha from "@/util/domainsForCaptcha";
import VueRecaptcha from "vue-recaptcha";
import ChangePassword from "./passwordRegistration";

export default {
  name: "loginForm",
  props: ["urlRedirect"],
  components: {
    VueRecaptcha,
    ChangePassword,
  },
  data: () => ({
    title: "Login",
    show1: false,
    valid1: false,
    valid2: false,
    valid3: false,
    formLogin: true,
    formRecov: false,
    formRecovLogin: false,
    loading: false,
    sendLink: true,
    migrationUserEmail: "",
    user: {
      login: "",
      password: "",
    },
    recoverPass: {
      login: "",
    },
    recoverLogin: {
      cpf: "",
    },
    rules: {
      required: validate.required,
      validEmail: validate.validEmail,
      max: validate.max,
    },
    backofficeLink: "",
    sendingChannel: "phone",
    manyInvalidLoginAttempts: false,
    cantResend: false,
    resendingEmail: false,
    // domainsForCaptcha: ["betclub7", "cartola", "betpremier", "pingolbet", "betpix"],
    domainsForCaptcha: ["betclub7", "betpremier", "pingolbet", "betpix"],
    loadRecaptcha: false,
    disabledBtnLogin: false,
  }),
  computed: {
    changePasswordDialog() {
      return this.$store.state.changePasswordDialog;
    },
    lang() {
      return this.$store.state.language;
    },
    flagLanguage() {
      return this.$store.state.flagLanguage;
    },
  },
  beforeMount() {
    // Ativando o captcha para os domínios definidos na lista;
    if (domainsForCaptcha.includes(this.$domain())) {
      this.loadRecaptcha = true;
    }
  },
  mounted() {
    // console.log(this.$route.query.lang)
    // console.log(langLocal)
    const langLocal = localStorage.getItem("language");
    if (this.$route.query.lang != "pt" && langLocal == "") {
      localStorage.setItem("language", this.$route.query.lang);
      this.$store.commit("setLanguage", this.$route.query.lang);
    }

    if (this.$route.query.login) {
      this.user.login = this.$route.query.login;
    }

    let domain = this.$domain();
    if (domain == "sys") {
      this.backofficeLink = `https://backoffice.sys.bet/auth/login/${domain}`;
    } else {
      this.backofficeLink = `https://backoffice.sga.bet/auth/login/${domain}`;
    }
  },
  methods: {
    resendEmail() {
      this.resendingEmail = true;
      const body = { domain: this.$domain(), email: this.migrationUserEmail };
      this.$axios
        .post("player/user/resendMigrationEmail", this.$formdata(body))
        .then((res) => {
          this.cantResend = true;
          this.$store.commit("setNotification", {
            msg: res.data.messages,
            color: "success",
          });
        })
        .catch((err) => {
          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        })
        .finally(() => {
          this.resendingEmail = false;
        });
    },
    showPassword() {
      this.show1 = !this.show1;
    },

    // Validação do backend do recaptcha.
    onVerify: function(response) {
      const headers = {
        "Content-Type": "application/json",
      };
      const endpoint =
        "https://0m5iy0epbc.execute-api.us-east-2.amazonaws.com/recaptcha";
      axios
        .post(endpoint, { token: response }, { headers: headers })
        .then((resp) => {
          const data = resp.data;
          if (data.success) {
            this.doLogin();
          } else {
            this.disabledBtnLogin = false;
            const msg = "Error de validação!";
            const color = "warning";
            this.$store.commit("setNotification", {
              msg,
              color,
            });
          }
        })
        .finally(() => this.$refs.invisibleRecaptcha.reset());
    },

    onExpired: function() {
      console.log("Expired");
    },

    handlerLogin() {
      // 1. Validar formulário
      if (this.$refs.form1.validate()) {
        // 2. Validar reCaptcha Google
        if (this.loadRecaptcha) {
          this.disabledBtnLogin = true;
          // Ao executar o recptcha ele retorna um token e chama a função de callback "onVerify"
          // que faz a validação no backend.
          this.$refs.invisibleRecaptcha.execute();
        } else {
          const storageResendVerifySmsTokenCounter = localStorage.getItem(
            "resendVerifySmsTokenCounter"
          );

          if (
            this.$store.state.operators.multifactor == 1
            && storageResendVerifySmsTokenCounter
            && storageResendVerifySmsTokenCounter > Date.now()
          ) {
            this.$store.commit("setDialogVerifySmsToken", {
              status: true,
              typeVerification: "twoStepsAuthentication",
              login: this.user.login,
              password: this.user.password,
            });

            this.$emit("closeDialog");
          } else {
            // 3. Login normal sem captcha
            this.doLogin();
          }
        }
      }
    },

    // AUTH LOGIN
    doLogin(data = null) {
      this.$Progress.start();
      this.loading = true;
      this.disabledBtnLogin = true;

      const newPassword = data && data.newPassword ? data.newPassword : null;

      this.$login(this.user.login, this.user.password, newPassword)
        .then((resolve) => {
          this.$Progress.finish();

          if (resolve.statusCode === 202) {
            return resolve.statusCode;
          }

          this.$store.commit("showChangePasswordDialog", false);

          this.$store.commit("setNotification", {
            msg: resolve.message,
            color: "green",
          });

          this.$gtag.login();
        })
        .then((statusCode) => {
          this.$Progress.finish();

          if (
            this.$route.path.includes("casino/lobby")
            && statusCode != 202
          ) {
            this.$router.push(this.urlRedirect ? this.urlRedirect : "/");
          } else if (statusCode != 202) {
            this.$router.push(this.urlRedirect ? this.urlRedirect : "/");
          }

          this.$emit("closeDialog");

          if (this.$store.state.showDialogRegister) {
            this.$store.commit("showDialogRegister", false);
          }
        })

        .catch((error) => {
          if (!this.$isAgent()) {
            this.lastWrongPassword = this.user.password;

            const responseData =
              error.response.data && error.response.data.dados;
            if (responseData && responseData.attempts >= 3) {
              this.manyInvalidLoginAttempts = true;
            }
          }
          if (error.response.data.messages.error) {
            this.$store.commit("setNotification", {
              msg: error.response.data.messages.error,
              color: "warning",
            });
          } else if (
            error.response.data.dados &&
            error.response.data.dados.migrating_user
          ) {
            this.$store.state.showMigrationUserLoginMessage = true;
            this.migrationUserEmail = error.response.data.dados.email;
            this.title = this.$t("welcomeToTheNewPlatform");
          }
          this.$Progress.fail();
        })
        .finally(
          () => ((this.loading = false), (this.disabledBtnLogin = false))
        );
    },

    // Open Dialog Recover Password
    openRecoverPassword() {
      this.formLogin = false;
      this.formRecovLogin = false;
      this.formRecov = true;
      if (this.manyInvalidLoginAttempts) {
        this.recoverPass.login = this.user.login;
      }
      this.manyInvalidLoginAttempts = false;
    },

    // Open Dialog Recover Login
    openRecoverLogin() {
      this.formLogin = false;
      this.formRecov = false;
      this.formRecovLogin = true;
      this.manyInvalidLoginAttempts = false;
    },

    // Open Dialog Login
    loginModal() {
      this.formLogin = true;
      this.formRecov = false;
      this.formRecovLogin = false;
    },

    // RECOVER PASSWORD
    recoverPassword() {
      const params = {
        domain: this.$domain(),
        login: this.recoverPass.login,
        choose_send: this.recoverPass.choose_send,
        url_client: `${window.location.protocol}//${window.location.hostname}/`,
      };
      this.loading = true;
      this.$axios
        .post("player/register/recoverPassword", this.$formdata(params))
        .then((resp) => {
          this.formLogin = true;
          this.formRecov = false;
          this.formRecovLogin = false;
          this.title = "Login";
          this.$refs.form2.reset();
          this.$store.commit("setNotification", {
            msg: resp.data.messages,
            color: "green",
          });
        })
        .catch((error) => {
          const msg = error.response.data.messages.error;
          const color = "warning";
          this.$store.commit("setNotification", {
            msg,
            color,
          });
        })
        .finally(() => (this.loading = false));
    },

    // RECOVER LOGIN (username)
    recoverUsername() {
      const body = {
        domain: this.$domain(),
        cpf: this.recoverLogin.cpf.replace(/[^0-9]+/g, ""),
        url_client: `${window.location.protocol}//${window.location.hostname}/`,
        choose_send: !this.$permissions().registerEmail
          ? this.sendingChannel
          : "email",
      };
      this.loading = true;
      this.$axios
        .post("player/online/register/recoverLogin", this.$formdata(body))
        .then((resp) => {
          this.formLogin = true;
          this.formRecov = false;
          this.formRecovLogin = false;
          this.$refs.form3.reset();
          this.$store.commit("setNotification", {
            msg: resp.data.messages,
            color: "green",
          });
        })
        .catch((error) => {
          const msg = error.response.data.messages.error;
          const color = "warning";
          this.$store.commit("setNotification", {
            msg,
            color,
          });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
